if (process.client) {
  document.body.id = 'ebo-app' // For specificity
}
